import React, { useState } from 'react';
import { supabase } from '../../services/supabaseClient';
import capitalismImage from '../../assets/articles/end-of-capitalism.jpg';
import rebelsImage from '../../assets/articles/heretics-outcasts-and-rebels.jpg';

// Keep these existing article images on our own host instead of hotlinking.
const bundledImages: Record<string, string> = {
  'https://images.saatchiart.com/saatchi/417953/art/7994961/7062291-HSC00001-32.jpg': capitalismImage,
  'https://media.tate.org.uk/art/images/work/N/N02/N02071_9.jpg': rebelsImage,
};

export const resolveImageUrl = (source: string): string => {
  const value = source.trim();
  if (bundledImages[value]) return bundledImages[value];
  if (/^(https?:\/\/|\/|data:image\/|blob:)/i.test(value)) return value;
  return supabase.storage.from('article_images').getPublicUrl(value).data.publicUrl;
};

const ArticleImage: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({ src, alt, onError, ...props }) => {
  const [failedSource, setFailedSource] = useState<string>();
  if (!src) return null;
  if (failedSource === src) {
    return <div className="flex min-h-[180px] items-center justify-center rounded-lg bg-gray-100 p-6 text-sm text-gray-500" role="img" aria-label={alt}>Image unavailable</div>;
  }
  return <img {...props} src={resolveImageUrl(src)} alt={alt} referrerPolicy="no-referrer" decoding="async" onError={event => { setFailedSource(src); onError?.(event); }} />;
};
export default ArticleImage;
